import React, { useCallback, useEffect } from 'react';
import { Checkbox, Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {
    CheckCircle as CircleChecked,
    RadioButtonUnchecked as CircleUnchecked,
} from '@mui/icons-material';
import { partial, times } from 'lodash';
import useTaskField from '@dyl/pages/Tasks/edit/useTaskField';
import ImagePicker from '@dyl/components/ImagePicker';

export default function TaskRadioImagesBlock({
    path = [''],
    hasCheckbox = true
}) {
    useEffect(() => {
        console.assert(!!path, 'No path specified!');
    }, [path]);

    const [array] = useTaskField(path);

    return (
        <Grid container spacing={2}>
            {times(array?.length, index => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                    <Item parent={path} index={index} hasCheckbox={hasCheckbox}/>
                </Grid>
            ))}
        </Grid>
    );
}

const useItemStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
    },
}));

function Item({ parent, index, hasCheckbox }) {
    const classes = useItemStyles();
    const useField = partial(useTaskField, parent, index);

    const [, setItems] = useTaskField(parent);

    const [imageId, setImageId, imageError] = useField('image_id');
    const [isCorrect] = useField('is_correct_answer');

    const setAsCorrect = useCallback(() => {
        setItems(prev => prev.map((a, i) => ({
            ...a,
            is_correct_answer: i === index,
        })));
    }, [index, setItems]);

    const letterId = String.fromCharCode('A'.charCodeAt(0) + index);

    return (
        <div className={classes.root}>
            {hasCheckbox && <Checkbox
                checked={isCorrect}
                onClick={setAsCorrect}
                icon={<CircleUnchecked />}
                checkedIcon={<CircleChecked />}
                color='primary'
            />
            }

            <ImagePicker
                label={`Image ${letterId}`}
                value={imageId}
                onChange={setImageId}
                fullWidth
                error={!!imageError}
                helperText={imageError ?? (hasCheckbox ? 'Select if key' : '')}
            />
        </div>
    );
}